export default __webpack_public_path__ + "static/prazske-jaro-1968-c12046826737210b53772d256f24632c.avif";